/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Created/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Created({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Content/SyncAction/Content/Action/Content/Created"
  
}) {
  return null
}